<template>
    <div class="kiosk-welcome-screen d-flex flex-column justify-content-center align-items-center text-center h-100 p-4">
      <div class="kiosk-welcome-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="kiosk-welcome-icon mb-4 text-primary"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path><line x1="8" y1="10" x2="16" y2="10"></line><line x1="8" y1="14" x2="13" y2="14"></line></svg>
        <h1 class="kiosk-welcome-title display-4 mb-3">{{ conferenceTitle }}</h1>
        <p class="kiosk-welcome-text lead mb-5">{{ welcomeMessage }}</p>
        <button @click="$emit('start-chat')" class="btn btn-primary btn-lg kiosk-welcome-start-button px-5 py-3" aria-label="Start chat session">
          Tap to Start Chat
        </button>
      </div>
    </div>
</template>

<script>

export default {
  props: {
    conferenceTitle: {
      type: String,
      default: 'Conference Assistant',
    },
    welcomeMessage: {
      type: String,
      default: 'Tap below to ask questions about the event schedule, speakers, or locations.',
    },
  },
};
</script>